import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {RoleCheckService} from '../shared/services/role-check.service';
import {APP_ROUTES} from '../app.routes';

export const RoleBasedRedirectGuard: CanActivateFn = async (): Promise<boolean> => {
  const roleCheckService = inject(RoleCheckService);
  const router = inject(Router);

  if (roleCheckService.hasSelecthorAdminRole()) {
    await router.navigate([APP_ROUTES.SELECTHOR_ADMIN_DASHBOARD]);
    return false;
  }

  if (roleCheckService.hasProviderAdminRole() || roleCheckService.hasProviderUserRole()) {
    await router.navigate([APP_ROUTES.PROVIDER]);
    return false;
  }

  return true;
};
